export const autocompletePt = {
  inputMultiple: 'pv-autocomplete-multiple',
  root: 'pv-autocomplete-input-container',
  pcChip: { root: 'pv-option-selected' }
};